export default new class Signature {
    init(){
        let text = "Developed by Studio Simone";
        let style = "height: 40px; width: 40px; padding: 30px 10px; line-height: 0px; font-family: Arial; font-weight: bold;";

        // console.log('%c '.concat(text), style);
    }
}